export const COGNITO_ERROR_CODES = {
  BAD_REQUEST: 400,
  INVALID_REQUEST: 401,
  UNAUTHORIZED: 403,
} as const;

export type CognitoErrorCode = typeof COGNITO_ERROR_CODES[keyof typeof COGNITO_ERROR_CODES];

export const ERROR_TYPES = {
  COGNITO: 'cognito_error',
  GENERIC: 'generic_error',
} as const;

export const isCognitoErrorCheck = (statusCode: number | null): boolean => {
  if (typeof statusCode !== 'number') {
    return false;
  }

  return Object.values(COGNITO_ERROR_CODES).includes(statusCode as CognitoErrorCode);
};
